import request from '../request/index'

/**
 * 获取jssdk初始化参数
 */

export function getJsSDKParams(data) {
  return request({
    url: '/wechat/getJsSDKParams',
    method: 'post',
    data
  })
}